export type ProviderClientParam = {
  clientId: string;
  baseUrl: string;
};

export type GetProviderListParam = {
  email?: string;
  provisionUser?: boolean;
};

export enum ProviderOrigin {
  email = 'email',
  domain = 'domain',
  default = 'default'
}

export type GetProviderListResponseType = ProviderType[];

export type ProviderType = {
  name: string;
  authorizationEndpoint: string;
  origin: ProviderOrigin[];
};
